import React, { useState, useEffect, useCallback, useMemo } from "react";
import TextStyles from "../../components/Elements/TextStyles/TextStyles";
import CustomButton from "../../components/Elements/Buttons/CustomButtons";
import { ReactComponent as EditIcon } from "../../assets/svgs/greenEdit.svg";
import { ReactComponent as DeleteIcon } from "../../assets/svgs/delete.svg";
import { useNavigate } from "react-router-dom";
import { Tables } from "../../components/Elements/Tables/Tables";
import EditRoles from "./DIalogBoxes/EditRoles";
import { SearchBar } from "../../components/Elements/Search/SearchBar";
import SortData from "../../components/Elements/SortData/SortData";
import { deleteApi, getApi } from "../../api/api_instance";
import { ReactComponent as Back } from "../../assets/svgs/back-button.svg";
import { API_URLS } from "../../api/apiUrls";
import CreateRoles from "./DIalogBoxes/CreateRoles";
import { toast } from "react-toastify";
import SuccessDailogBox from "../../components/Elements/DailogBox/SuccessDailogBox";
import PopupCard from "../../components/Cards/PopupCard/PopupCard";

const RolesPage = () => {
  const navigate = useNavigate();
  const [openEditDialog, setOpenEditDialog] = useState(false);
  const [selectedRole, setSelectedRole] = useState(null);
  const [roles, setRoles] = useState([]);
  const [openCreateDialog, setOpenCreateDialog] = useState(false);
  const [sortBy, setSortBy] = useState(null);
  const [sortOrder, setSortOrder] = useState(null);
  const [total, setTotal] = useState(0);
  const [loading, setLoading] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const [createRoleSuccessMsg, setCreateRoleSuccessMsg] = useState(false);
  const [createRoleFailMsg, setCreateRoleFailMsg] = useState(false);
  const [deleteRolePopup, setDeleteRolePopup] = useState(false);
  const [editSuccessPopup, setEditSuccessPopup] = useState(false);
  const [popup, setPopup] = useState({
    visible: false,
    type: "", // "success" | "error" | "warning"
    title: "",
    message: "",
  });

  const headers = useMemo(
    () => [
      { label: "Sr. No.", key: "serial" },
      { label: "Role", key: "role" },
      { label: "Description", key: "description" },
      { label: "Action", key: "action" },
    ],
    []
  );

  const showPopup = (type, title, message, duration = 3000) => {
    setPopup({ visible: true, type, title, message });
    setTimeout(() => {
      setPopup({ visible: false, type: "", title: "", message: "" });
    }, duration);
  };

  const fetchRoles = useCallback(async () => {
    try {
      setLoading(true);
      const response = await getApi({ apiUrl: API_URLS.ALL_ROLES });
      const data = response?.data?.docs || [];

      const transformedData = data.map((item, index) => ({
        key: item._id,
        serial: index + 1,
        role: item.Role,
        description: item.Description,
        action: (
          <div className="flex gap-4 items-center justify-center">
            <EditIcon
              style={{ marginRight: 10, cursor: "pointer" }}
              onClick={() => handleEditRole(item._id)}
            />
            <DeleteIcon
              style={{ cursor: "pointer" }}
              onClick={() => handleDeleteRole(item._id)}
            />
          </div>
        ),
      }));

      setRoles(transformedData);
      setTotal(transformedData.length);
    } catch (error) {
      console.error("Error fetching roles:", error);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    fetchRoles();
  }, [fetchRoles]);

  const handleEditRole = async (roleId) => {
    try {
      setLoading(true);
      const response = await getApi({ apiUrl: API_URLS.ROLE_BY_ID(roleId) });
      const roleData = response?.data;
      setSelectedRole(roleData);
      setOpenEditDialog(true);
    } catch (error) {
      console.error("Error fetching role by ID:", error);
    } finally {
      setLoading(false);
    }
  };

  const handleDeleteRole = async (roleId) => {
    try {
      const res = await deleteApi({ apiUrl: API_URLS.DELETE_ROLE(roleId) });
      if (res.success) {
        setDeleteRolePopup(true);
        showPopup("error", "Error", "Failed to delete role");
        fetchRoles();
      } else {
        showPopup("error", "Error", "Failed to delete role");
      }
    } catch (error) {
      showPopup("error", "Error", "Failed to delete role");
    }
  };

  const handleSort = (key, order) => {
    setSortBy(key);
    setSortOrder(order);
  };

  const sortedData = useMemo(() => {
    let data = [...roles];
    if (sortBy && sortOrder) {
      data = SortData({ data, key: sortBy, order: sortOrder });
    }
    return data;
  }, [roles, sortBy, sortOrder]);

  useEffect(() => {
    if (createRoleSuccessMsg) {
      showPopup(
        "success",
        "Created",
        "Role and Permissions Created Successfully"
      );
      setCreateRoleSuccessMsg(false);
    }
  }, [createRoleSuccessMsg]);

  useEffect(() => {
    if (createRoleFailMsg) {
      showPopup(
        "error",
        "Failed",
        "Role with given field is already exist"
      );
      setCreateRoleFailMsg(false);
    }
  }, [createRoleFailMsg]);




  
  useEffect(() => {
    if (editSuccessPopup) {
      showPopup(
        "success",
        "Updated",
        "Role and Permissions Edited Successfully"
      );
      setEditSuccessPopup(false);
    }
  }, [editSuccessPopup]);

  useEffect(() => {
    if (deleteRolePopup) {
      showPopup(
        "success",
        "Deleted",
        "Role and Permissions Deleted Successfully"
      );
      setDeleteRolePopup(false);
    }
  }, [deleteRolePopup]);

  return (
    <div>
      <div
        style={{ padding: "40px", backgroundColor: "#fff" }}
        className="h-screen"
      >
        <div>
          <div className="flex justify-end text-xs font-light p-3">
            <p>Home</p>
            <span>/</span>
            <TextStyles color="gradient">Roles and Permissions</TextStyles>
          </div>
          <div>
            <div className="flex items-center mb-6 gap-2 text-xl text-[#06513D] font-bold px-2">
              {/* <Back onClick={() => navigate(-1)} className="cursor-pointer" /> */}
              <div>Roles and Permission</div>
            </div>

            <div
              style={{
                border: "1px solid #ebedf3",
                borderRadius: "10px",
                paddingTop: "20px",
              }}
            >
              <div className="flex justify-between px-3 mb-3">
                <div className="flex gap-4 pl-9">
                  <div className="px-8 h-[42px] flex items-center justify-center border border-[#06513D] bg-[#B6D4D933] rounded-md text-[#06513D] text-base font-light">
                    TOTAL ROLES {total}
                  </div>

                  {/* <SearchBar width="300px" onSearch={setSearchTerm} />  */}
                </div>

                <div className="flex gap-4">
                  <CustomButton
                    buttonType="button"
                    variant="ok"
                    buttonText=" + Add New"
                    onClick={() => setOpenCreateDialog(true)}
                    className="text-base font-normal h-[50px] w-[160px]"
                  />
                </div>
              </div>
              <Tables
                data={sortedData}
                headers={headers}
                pageSize={7}
                sortBy={sortBy}
                sortOrder={sortOrder}
                loading={loading}
                onSort={handleSort}
              />
            </div>

            {openCreateDialog && (
              <CreateRoles
                onOpen={openCreateDialog}
                onClose={() => setOpenCreateDialog(false)}
                fetchRoles={fetchRoles}
                onSave={() => setCreateRoleSuccessMsg(true)}
                onSucessFail={()=>setCreateRoleFailMsg(true)}
              />
            )}

            {openEditDialog && (
              <EditRoles
                onOpen={openEditDialog}
                onClose={() => setOpenEditDialog(false)}
                roleId={selectedRole?._id}
                roleData={selectedRole}
                fetchRoles={fetchRoles}
                onSave={() => setEditSuccessPopup(true)}
              />
            )}

            {/* {createRoleSuccessMsg && (
              <SuccessDailogBox
                onOpen={createRoleSuccessMsg}
                onClose={() => setCreateRoleSuccessMsg(false)}
                popuptype="success"
                successMessage={"Role and Permissions Created Successfully"}
              />
            )}

            {editSuccessPopup && (
              <SuccessDailogBox
                onOpen={editSuccessPopup}
                onClose={() => setEditSuccessPopup(false)}
                popuptype="success"
                successMessage={"Role and Permissions Edited Successfully"}
              />
            )}

            {deleteRolePopup && (
              <SuccessDailogBox
                onOpen={deleteRolePopup}
                onClose={() => setDeleteRolePopup(false)}
                popuptype="delete"
                successMessage={"Role and Permissions Deleted Successfully"}
              />
            )} */}

            {popup.visible && (
              <div className="fixed inset-0  bg-black/30 z-[9999] flex items-center justify-center">
                <PopupCard
                  type={popup.type}
                  title={popup.title}
                  message={popup.message}
                />
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default RolesPage;
